// Para birimi yardımcıları — COP deal tutarları KARIŞIK para birimli
// olabilir (Smartsheet'ten USD, manuel TRY vb.). Toplamlar asla tek ₺
// altında toplanmaz; para birimi başına ayrı gösterilir.
export const CURRENCY_SYMBOLS = { TRY: "₺", USD: "$", EUR: "€", GBP: "£" };

export const curSymbol = (c) => CURRENCY_SYMBOLS[c] || c || "₺";

export function fmtCompact(v, curr = "₺") {
  const n = Number(v) || 0;
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${sign}${(abs / 1_000_000).toFixed(1)}M ${curr}`;
  if (abs >= 1_000) return `${sign}${(abs / 1_000).toFixed(0)}K ${curr}`;
  return `${sign}${abs.toFixed(0)} ${curr}`;
}

export function sumByCurrency(deals, valueOf = (d) => Number(d.value) || 0) {
  const map = {};
  for (const d of deals || []) {
    const c = d.currency || "TRY";
    map[c] = (map[c] || 0) + valueOf(d);
  }
  return map;
}

// {TRY: 58900000, USD: 1200000} -> "58.9M ₺ + 1.2M $" (büyükten küçüğe)
export function fmtMulti(byCur) {
  const entries = Object.entries(byCur || {})
    .filter(([, v]) => Math.round(Number(v) || 0) !== 0)
    .sort((a, b) => Math.abs(b[1]) - Math.abs(a[1]));
  if (entries.length === 0) return fmtCompact(0);
  return entries.map(([c, v]) => fmtCompact(v, curSymbol(c))).join(" + ");
}
